import { useGetETSTicketNotificationsCountForChannelSelector } from 'gcs-common/clients/api/entities/tickets/tickets-api-selectors';
import {
  getChannelBrand,
  getChannelImage,
  getChannelMemberCount,
  getChannelStatus,
  getChannelSubtitle,
  getChannelTitle,
  getIsHidden,
  getIsSalesSpaceChannelType,
  getIsSelectedChannel,
  getNumOpenTasksForChannel,
  getOtherMemberTyping,
} from 'gcs-common/slices/channel/channelSelectors';
import changeSelectedChannelId from 'gcs-common/slices/channels/channelsThunks/changeSelectedChannelId';
import { getUnreadMessageCountForChannel } from 'gcs-common/slices/channels/unreadMessagesSelectors';
import { useDispatch, useSelector } from 'react-redux';
import ChannelListItemNormal from '../ChannelListItemNormal/ChannelListItemNormal';

interface ChannelListItemNormalWithIdProps {
  channelId: string;
}

const ChannelListItemNormalWithId = ({ channelId }: ChannelListItemNormalWithIdProps) => {
  const numOpenTasks = useSelector(getNumOpenTasksForChannel(channelId));
  const ticketNotificationsCount = useGetETSTicketNotificationsCountForChannelSelector(channelId);
  const tasksAndTickets = numOpenTasks + ticketNotificationsCount;
  const channelBrand = useSelector(getChannelBrand(channelId));
  const isSelectedChannel = useSelector(getIsSelectedChannel(channelId));
  const unreadCount = useSelector(getUnreadMessageCountForChannel(channelId));
  const otherUserTyping = useSelector(getOtherMemberTyping(channelId));
  const channelImage = useSelector(getChannelImage(channelId));
  const channelStatus = useSelector(getChannelStatus(channelId));
  const channelTitle = useSelector(getChannelTitle(channelId));
  const channelSubtitle = useSelector(getChannelSubtitle(channelId));
  const channelMemberCount = useSelector(getChannelMemberCount(channelId));
  const isSalesSpace = useSelector(getIsSalesSpaceChannelType(channelId));
  const isHidden = useSelector(getIsHidden(channelId));

  const dispatch = useDispatch();

  const selectChannel = () => {
    dispatch(changeSelectedChannelId({ selectedChannelId: channelId }));
  };

  return (
    <ChannelListItemNormal
      channelId={channelId}
      isSelectedChannel={isSelectedChannel}
      unreadCount={unreadCount}
      otherUserTyping={!!otherUserTyping}
      channelImage={channelImage}
      channelStatus={channelStatus}
      channelTitle={channelTitle}
      channelSubtitle={channelSubtitle}
      onChannelSelect={selectChannel}
      numOpenTasks={tasksAndTickets}
      channelBrand={channelBrand}
      channelMemberCount={channelMemberCount}
      isSalesSpace={isSalesSpace}
      isHidden={isHidden}
    />
  );
};

export default ChannelListItemNormalWithId;
